import { render, staticRenderFns } from "./create-edit.vue?vue&type=template&id=3fa8c752"
import script from "./create-edit.vue?vue&type=script&lang=js"
export * from "./create-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports